import { AbstractViewProperties } from "../../view/properties/AbstractViewProperties";
import { HorizontalLayout } from "../layout/HorizontalLayout";
/**
 * PanelProperties.ts
 */
export class PanelProperties extends AbstractViewProperties {
    constructor(position, size) {
        super(position);
        this.size = size;
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            (this.size ? this.size.equals(other.size) : !other.size) &&
            this.layout.equals(other.layout) &&
            (this.useMask === other.useMask);
    }
    setDefaultValues() {
        this.useMask = false;
        this.layout = new HorizontalLayout(0);
    }
}
//# sourceMappingURL=PanelProperties.js.map